import { isString } from "lodash";
import { isBigNumber } from "mathjs";

import { MATRIX_LATEX } from "./consts";
import { structEqual } from "./exprEquality/structEqual";
import { MathPrimitive } from "./extendMath";
import { isMathNode } from "./operations";

export function areValuesEqual(a: MathPrimitive, b: MathPrimitive): boolean {
  if (isBigNumber(a) && isBigNumber(b)) {
    return Math.abs(a.toNumber() - b.toNumber()) < 0.01;
  }

  if (isString(a) && isString(b)) {
    if (a.includes(MATRIX_LATEX)) {
      // spaces inside matrix expression don't have any effect, so can remove to normalize
      return a.replaceAll(" ", "") === b.replaceAll(" ", "");
    }
    return a.toLocaleLowerCase().trim() === b.toLocaleLowerCase().trim();
  }

  if (isMathNode(a) && isMathNode(b)) {
    return structEqual(a, b);
  }

  return false;
}
